module.exports = __webpack_public_path__ + "img/wijk-tariff.27176f6c.png";